/**
 * Extracts YouTube video ID from various URL formats
 * Supports regular youtube.com, youtu.be, mobile youtube, and URLs with tracking parameters
 */
export const extractVideoId = (url: string): string | null => {
  if (!url) return null;
  
  // Try to match youtu.be format (e.g., https://youtu.be/dQw4w9WgXcQ)
  let match = url.match(/youtu\.be\/([^\/\?&]+)/);
  if (match && match[1]) return match[1];
  
  // Try to match youtube.com?v= format (standard and mobile)
  match = url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/);
  if (match && match[1]) return match[1];
  
  // Try to match youtube.com/shorts format
  match = url.match(/youtube\.com\/shorts\/([^\/\?&]+)/);
  if (match && match[1]) return match[1];

  return null;
};

/**
 * Validates if the extracted ID is a valid YouTube video ID
 */
export const isValidYoutubeId = (id: string | null): boolean => {
  if (!id) return false;
  
  // YouTube IDs are typically 11 characters and contain only certain characters
  return /^[a-zA-Z0-9_-]{11}$/.test(id);
};